import React, { useState } from 'react'

import i18n from 'live/services/i18n'

import { PresetsContainer, ReportItems } from './style'

interface IProps {
    setPreset: (k: string | null) => void
}

export const Presets: React.FC<IProps> = ({ setPreset }) => {
    const [selected, setSelected] = useState<number>()
    const presets = [
        i18n('Risk Acceptance / Risk Level'),
        i18n('Resource Threat Status'),
        i18n('Resource Consequence Status'),
        i18n('Resource Barrier Status'),
        i18n('Resource Barrier PFD'),
        i18n('Manual Interaction Barriers Status'),
        i18n('Current Mandatory Barriers'),
        i18n('Resource Barrier Analysis')
        // 'Escalation Factor Qualitative Barriers'
    ]

    const onSelect = (el: string, index: number): void => {
        setPreset(el)
        setSelected(index)
    }

    const presetButtons = presets.map((preset, index) => {
        return (
            <button key={preset} className={selected === index && 'selected'} onClick={() => onSelect(preset, index)}>
                {preset}
            </button>
        )
    })

    return (
        <PresetsContainer>
            <span>{i18n('PRESETS')}</span>
            <ReportItems>{presetButtons}</ReportItems>
        </PresetsContainer>
    )
}
